import { render } from "./EditorsContent.vue?vue&type=template&id=e7a20830&ts=true"
import script from "./EditorsContent.vue?vue&type=script&lang=ts"
export * from "./EditorsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__